// ----------------------------------------------------------------------

export const mockImgAvatar = (index) => `/static/mock-images/avatars/avatar_${index}.jpg`;
